import i18n from "i18n";

const headers = {
  // image: {
  //   name: 'image',
  //   title: ' ',
  //   active: false,
  //   direction: false
  // },
  name: {
    name: 'name',
    title: i18n.t("name").toUpperCase(),
    active: false,
    direction: false,
    value: "username",
  },
  email: {
    name: 'email',
    title: i18n.t("email").toUpperCase(),
    active: false,
    direction: false,
    value: "email",
  },
  role: {
    name: 'role',
    title: i18n.t("role").toUpperCase(),
    active: false,
    direction: false,
    hideOrdering: true,
  },
  status: {
    name: 'status',
    title: i18n.t("status").toUpperCase(),
    active: false,
    direction: false,
    hideOrdering: true,
  },
}

export default headers;